import * as React from "react";
import PropTypes from "prop-types";
import { useSession } from "@hooks";

type OccupationRightsAreaProps = {
  //
};

const languagesVarsCodes = [
  "LANG_neobooking_area_occupation_rights_title", //Crédits séjour
]

const OccupationRightsArea: React.FC<OccupationRightsAreaProps> = () => {

  /* Hooks */
  const { getLanguageVarValue } = useSession();

  return <div>
    <span className="tw-block tw-font-bold">{getLanguageVarValue("LANG_neobooking_area_occupation_rights_title")}</span>
  </div>;
};

OccupationRightsArea.propTypes = {
  //
};

export default OccupationRightsArea;
